import { IMAGE_TAG } from '../constants/editable-elements';
import isExternalImage from '../verifiers/is-external-image';

const getExternalImages = (element) => {
  const pasteImages = Array.from(element.querySelectorAll(IMAGE_TAG));

  return pasteImages.filter(isExternalImage);
};

export default getExternalImages;
